import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { Button, Modal } from 'react-bootstrap';
import * as Fi from 'react-icons/fi';

import { Manifest } from 'services/action';

import { DatePicker, Select } from 'ui/components';
import { formatDate } from 'utilities/common';

const now = new Date();
const nextDay = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);

const actionOptions = [
  { value: 'redelivery', label: 'Kirim Ulang' },
  { value: 'return', label: 'Kembalikan' },
];

const initialState = {
  selectedAction: null,
  showReceive: false,
  isLoading: false,
  redeliveryAt: null,
  jobId: null
};

const LegsDetailItem = ({ manifest, legs, onSubmit }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const [{ showReceive, jobId, redeliveryAt, selectedAction }, setState] = React.useState(initialState);

  const $handleSelectedAction = (e) => {
    let redeliveryAt = null

    if (e?.value === 'redelivery') {
      redeliveryAt = {
        default: nextDay,
        formatted: formatDate(nextDay, 'YYYY-MM-DD'),
      }
    }

    setState((prevState) => ({
      ...prevState,
      selectedAction: e,
      redeliveryAt: redeliveryAt,
    }));
  };

  const $closeModal = async () => {
    setState((prevState) => ({
      ...prevState,
      jobId: null,
      showReceive: false,
    }));
  };

  const $openModal = (v) => {
    setState((prevState) => ({
      ...prevState,
      jobId: v,
      showReceive: true
    }));
  };

  const $handleReceive = async (id) => {
    const payload = {redelivery_at: redeliveryAt?.formatted, action: selectedAction?.value}
    const req = await Dispatch(Manifest.$receive(manifest?.id, legs?.id, id, payload));

    if (req?.message === 'success') {
      if (onSubmit) onSubmit();
      if (showReceive) $closeModal();
    }
  };

  const $handleUnreceive = async (id) => {
    const req = await Dispatch(Manifest.$unreceive(manifest?.id, legs?.id, id));

    if (req?.message === 'success') {
      if (onSubmit) onSubmit();
    }
  };

  if (!legs?.jobs) return null;

  return (
    <div className="mb-3 mt-3">
      <div className="datagrid-title">
        Daftar {legs?.type?.replace('_point', '')}
      </div>
      <div
        className="feature-listing border-top"
        style={{ maxHeight: 222, height: 'auto' }}
      >
        {legs?.jobs?.map((l, i) => (
          <div
            key={i}
            id={l?.delivery_order?.shipment?.code}
            className="border-bottom row bg-hover"
          >
            <div className="col-2 text-center">
              <h4 className="pt-4 ps-2">{i + 1}</h4>
            </div>
            <div className="col-7 table-col p-2">
              <small className="info text-uppercase">
                {l?.delivery_order?.shipment?.code}
              </small>
              <div className="fs-8 fw-bold text-uppercase">
                {l?.delivery_order?.shipment?.destination?.name}
              </div>
              <small className="info text-uppercase text-ellipsis">
                shipper: {l?.delivery_order?.shipment?.shipper?.name}
              </small>
            </div>
            <div className="col-3 text-center table-col">
              <div className="fs-8 fw-bold text-uppercase mt-3">
                {l?.delivery_order?.shipment?.total_quantity} Koli
              </div>
              <small className="info text-uppercase">
                {l?.delivery_order?.shipment?.total_weight} KG
              </small>
            </div>
            {legs?.is_receive &&
              (l?.status === 'delivered' || l?.status === 'unreceived') && (
                <div className="col-10 offset-2 pb-2">
                  {l?.status !== 'unreceived' && (
                    <button
                      className="btn btn-xs btn-danger me-2"
                      style={{ width: 100 }}
                      onClick={() => $handleUnreceive(l?.id)}
                    >
                      Tidak Diterima
                    </button>
                  )}
                  <button
                    className={cn('btn btn-xs btn-success')}
                    style={{ width: 100 }}
                    onClick={() => manifest?.type === 'last_mile' ? $openModal(l?.id) : $handleReceive(l?.id)}
                  >
                    Diterima
                  </button>
                </div>
              )}
          </div>
        ))}
      </div>

      <Modal
        show={showReceive}
        onHide={$closeModal}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$closeModal} />
          <div className="modal-status bg-primary" />
          <Fi.FiAlertTriangle className="mb-2 text-primary" size={90} />
          <h3>Anda yakin shipment telah diterima di lokasi?</h3>

          {manifest?.type === 'last_mile' && (
            <div className="mb-2 text-start">
              <label className='form-label required'>Tidak Lanjut</label>
              <Select
                required
                isClearable
                classNamePrefix={
                  StateForm?.errors?.repeat_type ? 'is-invalid' : 'select'
                }
                placeholder=""
                value={selectedAction}
                options={actionOptions}
                onChange={$handleSelectedAction}
                error={StateForm?.errors?.action}
              />

              {StateForm?.errors?.action ? (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  {StateForm?.errors?.action}
                </div>
              ) : null}
            </div>
          )}

          {selectedAction?.value === 'redelivery' && (
            <div className="mb-2 text-start">
              <label className="form-label fs-8 required">Jadwal Pickup</label>
              <div
                className={
                  StateForm?.errors?.etd_at
                  ? 'border border-danger rounded'
                  : ''
                }
              >
                <DatePicker
                  type="normal"
                  value={redeliveryAt?.default || null}
                  format="dd/MM/yyyy"
                  onChange={(date) =>
                    setState((prevState) => ({
                      ...prevState,
                      redeliveryAt: {
                        default: date,
                        formatted: formatDate(date, 'YYYY-MM-DD'),
                      },
                    }))
                  }
                  isShowTrigger
                />
              </div>
              {StateForm?.errors?.redelivery_at && (
                <div
                  className="invalid-feedback"
                  style={{ display: 'block' }}
                >
                  {StateForm?.errors?.redelivery_at}
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$closeModal}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="primary"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={() => $handleReceive(jobId)}
                disabled={StateForm?.loading}
              >
                Terima
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default LegsDetailItem;
